<template>
  <RouterLink :to="link" :event="disabled ? '': 'click'" class="v-centerer settings-item-component">
    <div class="f-w">{{ title }}</div>
    <Icon rotate-left>{{ arrowDownLine }}</Icon>
  </RouterLink>
</template>

<script>
/**
 * Visual components used as settings links.
 * @vue-prop link - link to the setttings page
 */

import Icon from '@/components/icon.vue';
import { arrowDownLine } from '@/assets/icons';

export default {

  name: 'SettingsItem',

  components: {
    Icon,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },

  data() {
    return {
      arrowDownLine,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.settings-item-component {
  background: white;
  border-radius: $high-border-radius;
  padding: 1rem;
  margin-bottom: $settings-items-margin;

  .icon {
    width: 1rem;
    height: 1rem;
  }
}
</style>
